module.exports = __webpack_public_path__ + "img/ctrl-u3-dagger-stub--i.ea9888bf.svg";